<template>
     <Splide :has-track="false" class="w-full mt-8" :options="options">
        <SplideTrack>
            <SplideSlide v-for="item in news.items" :key="item.id" class="lg:flex" :class="order === 'text_first' ? 'lg:flex-row-reverse' : ''">
                <div class="relative lg:flex-1 rounded-2xl overflow-hidden">
                    <span v-if="item.categories && item.categories.length" class="absolute top-0 right-0 z-10 inline-flex px-3 py-2 bg-dark uppercase text-mdx text-light font-medium tracking-wider" v-html="item.categories[0].cat_name"></span>

                    <a v-if="item.link && item.image" :href="item.link">
                        <img :src="item.image.url" class="rounded-3xl w-full h-60 lg:h-[380px] object-cover" :alt="item.image.alt ?? item.title">
                    </a>
                    
                    <img v-else-if="item.image" :src="item.image.url" class="rounded-3xl w-full h-60 lg:h-[380px] object-cover" :alt="item.image.alt ?? item.title">
                </div>

                <div
                    class="lg:flex-1 lg:flex lg:items-center py-8 lg:pl-16"
                    :class="order === 'text_first' ? 'lg:pr-16' : 'lg:pr-4'"
                >
                    <article class="relative">
                        <h3 v-if="item.title" class="mb-4 lg:mb-6 text-2xl lg:text-3xl" >
                            <a v-if="item.link" :href="item.link" v-html="item.title" class="hover:text-default transition-colors"></a>
                            <span v-else v-html="item.title"></span>
                        </h3>

                        <p v-if="item.subtitle" class="mb-6 lg:mb-0 font-regular text-base lg:text-lg" v-html="item.subtitle"></p>
                        
                        <a v-if="item.link" :href="item.link" class="lg:hidden font-medium underline hover:no-underline text-dark">Read article</a>
                    </article>
                </div>
            </SplideSlide>
        </SplideTrack>

        <div 
            class="splide__arrows absolute -bottom-8 lg:bottom-8 left-0 flex gap-2"
            :class="order === 'text_first' ? 'lg:left-16' : 'lg:left-1/2 lg:ml-3'"
        >
            <button class="splide__arrow--prev w-11 h-11 flex justify-center items-center bg-default hover:bg-default-tone rounded-full">
                <svg class="relative -left-px fill-dark" width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.22748 8.80219L2.37798 15.6517C1.94989 16.1155 1.20072 16.1155 0.772631 15.6517C0.308863 15.2236 0.308863 14.4744 0.772631 14.0463L6.80162 7.98167L0.772631 1.95269C0.308863 1.5246 0.308863 0.775431 0.772631 0.347338C1.20072 -0.11643 1.94989 -0.11643 2.37798 0.347338L9.22748 7.19684C9.69125 7.62493 9.69125 8.37409 9.22748 8.80219Z" />
                </svg>
            </button>

            <button class="splide__arrow--next w-11 h-11 flex justify-center items-center bg-default hover:bg-default-tone rounded-full">
                <svg class="relative -right-px fill-dark" width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9.22748 8.80219L2.37798 15.6517C1.94989 16.1155 1.20072 16.1155 0.772631 15.6517C0.308863 15.2236 0.308863 14.4744 0.772631 14.0463L6.80162 7.98167L0.772631 1.95269C0.308863 1.5246 0.308863 0.775431 0.772631 0.347338C1.20072 -0.11643 1.94989 -0.11643 2.37798 0.347338L9.22748 7.19684C9.69125 7.62493 9.69125 8.37409 9.22748 8.80219Z" />
                </svg>
            </button>
        </div>
    </Splide>
</template>
<script>
import { defineComponent } from "vue"
import { Splide, SplideSlide, SplideTrack } from '@splidejs/vue-splide';

export default defineComponent({
    components: {
        Splide,
        SplideSlide,
        SplideTrack,
    },
    data() {
        return {
            options: {
                pagination: false,
                interval: 3000,
                arrows: true,
                rewind: true,
                speed: 1500,
                perMove: 1,
            },
        }
    },
    props: {
        name: {
          type: String,
        }
    },
    computed: {
        news() {
            return window?.capes?.[this.name] ?? {}
        },
        order() {
            return this.news?.order ?? 'image_first'
        },
    },
})
</script>
